<template>
  <ProductPricePage
    :product="data.product"
    :product-data="data.productData"
    :subscription="subscription"
  >
    <NuxtPage
      :product="data.product"
      :product-data="data.productData"
      :subscription="data.subscription"
    />
  </ProductPricePage>
</template>

<script setup lang="ts">
import {
  RARE_EARTHS,
  MARKET,
  SUBSCRIPTION_PRICE_ASSESSMENTS_RARE_EARTHS,
} from '~/constants/services/constants'
import rareEarthsData from '~/constants/price-assessments/unauthorized/rare-earths'
import ProductPricePage from '~/components/market/ProductPricePage.vue'

/*-------------------------------------
    Meta
-------------------------------------*/
definePageMeta({ layout: 'services' })
const subscription = SUBSCRIPTION_PRICE_ASSESSMENTS_RARE_EARTHS
const data = {
  product: RARE_EARTHS,
  productData: rareEarthsData,
  subscription,
}

/*-------------------------------------
    SEO
-------------------------------------*/
const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${RARE_EARTHS.name} Prices`,
})
useHead(seo)
</script>
